module.exports = __webpack_public_path__ + "img/main_RCV.17581498.jpg";